import { Box } from '@mui/material';
import { SubmitButton } from '@root/components/v2/ui-elements/SubmitButton';
import { isEmpty } from 'lodash';
import { Search } from 'lucide-react';

const TenantSwitchingNew = props => {
  return (
    <div className="TenatSwitching__Container">
      <div className="TenatSwitching__SearchContainer">
        <Search className="icon" />
        <input type="text" placeholder="Search Tenant Name" value={props.value} onChange={props.onSearch} />
      </div>
      <div className="TenatSwitching__ContnentContainer CustomScrollbar">
        {isEmpty(props.templist) ? (
          <div className="TenatSwitching__EmptyList">No tenants</div>
        ) : (
          props.templist?.map(
            element =>
              element['tenant_name'] != localStorage.getItem('tenantName') && (
                <>
                  <Box
                    className={`TenatSwitching__Item ${
                      props.tempTenant.find(tenant => tenant.tenant_name === element.tenant_name)
                        ? 'TenatSwitching__Item--checked'
                        : ''
                    }`}
                    key={element['id']}
                    onClick={() => {
                      localStorage.removeItem('environments');
                      props.onTenantSelect(element);
                    }}>
                    {element['tenant_name']}
                  </Box>
                </>
              ),
          )
        )}
      </div>

      <div className="TenatSwitching__Footer">
        <SubmitButton
          onClick={() => {
            props.setTenant();
          }}
          disabled={props.checked}
          text={'Confirm'}
          style={{
            height: '23px',
            padding: '0 13px',
            margin: '10px 50px',
            fontSize: '12px',
            fontWeight: '500',
            borderRadius: '4px',
          }}
        />
      </div>
    </div>
  );
};

export default TenantSwitchingNew;
